import { render, staticRenderFns } from "./NordCoursePage.vue?vue&type=template&id=5937b2fc&"
import script from "./NordCoursePage.vue?vue&type=script&lang=js&"
export * from "./NordCoursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5937b2fc')) {
      api.createRecord('5937b2fc', component.options)
    } else {
      api.reload('5937b2fc', component.options)
    }
    module.hot.accept("./NordCoursePage.vue?vue&type=template&id=5937b2fc&", function () {
      api.rerender('5937b2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordCoursePage.vue"
export default component.exports